






































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import SitesSelector from "@/components/SitesSelector.vue";
import { LayoutModule } from "@/store/layout";
import { AvailabilityModule } from "@/store/availability";
import Site from "@/models/site";
import { AvailabilityFilterModel } from "@/models/availability";
import AdUnit, { AdUnitFilter } from "@/models/adUnit";
import AdUnitsSelector from "@/components/AdUnitsSelector.vue";
import DatePicker from "@/components/DatePicker.vue";
import { cloneDeep } from "lodash";
import moment from "moment";

@Component({ components: { SitesSelector, AdUnitsSelector, DatePicker } })
export default class AvailabilityFilter extends Vue {
  @Prop({ default: false }) disable_adunits!: boolean;
  @Prop({ default: false }) disable_dates!: boolean;

  filter: AvailabilityFilterModel = {
    site_id: "",
    ad_units: [],
  };
  dates: string[] = [moment().format(), moment().format()];

  get adUnitFilters(): AdUnitFilter {
    const filter = {
      filter: {
        site_ids: this.filter.site_id,
      },
      fields: { ad_unit: ["id", "ref", "name"].join(",") },
      page: {
        size: -1,
      },
    };
    return filter;
  }

  created(): void {
    AvailabilityModule.getFilter
      ? (this.filter = cloneDeep(AvailabilityModule.getFilter))
      : null;
    if (this.filter) {
      this.dates = [
        moment(this.filter.start).format(),
        moment(this.filter.end).format(),
      ];
    }
  }

  validate(): void {
    const validForm = (this.$refs.form as Vue & {
      validate: () => boolean;
    }).validate();
    validForm ? this.apply() : null;
  }

  setSite(site: Site): void {
    this.filter.site_id = site.toString();
    this.filter.ad_units = [];
  }

  cancel(clean = false): void {
    clean ? AvailabilityModule.setFilter(null) : null;
    LayoutModule.hideRightDrawer();
  }

  apply(): void {
    AvailabilityModule.setFilter(cloneDeep(this.filter));
    LayoutModule.hideRightDrawer();
  }

  onSelectAdUnit(): void {
    // this.selectedAdUnit = adUnit;
  }

  @Watch("dates")
  processDates(): void {
    if (this.dates.length == 2) {
      let first = moment(this.dates[0], "YYYY-MM");
      let last = moment(this.dates[1], "YYYY-MM");

      if (first.diff(last) >= 0) {
        const c = first;
        first = last;
        last = c;
      }

      last = moment(`${this.dates[1]}-${last.daysInMonth()}`, "YYYY-MM-DD");

      this.dates[0] = first.format("YYYY-MM-DD");
      this.dates[1] = last.format("YYYY-MM-DD");

      this.filter.start = first.toDate();
      this.filter.end = last.toDate();
    }
  }
}
